import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Which Intelligence page each workspace was last left on (P1 §3.3's
 * `lastIntelligenceRoute`), so `Enter Intelligence` returns there. For this
 * browser tab only. P1's other fields (the last ElfieCare screen, the patient
 * hand-off context) belong to ElfieCare and arrive with the move into it
 * (DECISIONS.md #17).
 */
export const useWorkspaceModeStore = defineStore('workspace-mode', () => {
  const lastIntelligenceRoute = ref<Record<string, string>>({})

  const remember = (workspaceId: string, fullPath: string): void => {
    lastIntelligenceRoute.value = { ...lastIntelligenceRoute.value, [workspaceId]: fullPath }
  }

  return { lastIntelligenceRoute, remember }
})
